import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Location } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { companyReportData } from 'src/environments/environment';
@Component({
  selector: 'app-alarmreport',
  templateUrl: './alarmreport.component.html',
  styleUrls: ['./alarmreport.component.scss'],
})
export class AlarmreportComponent implements OnInit {
  pdfHead: any = ['Plate No', "Alert Type", "Status", "Start Time", "End Time", "Time Duration"];

  constructor(
    private platform: Platform,
    private location: Location,
    private commonService: CommonService
  ) { }
  commonData: any;
  displayCount: number = 30;
  displayData: Array<any>;
  currentPage: number = 1;
  count = 10;
  doInfinite(event) {
    setTimeout(() => {
      this.displayData.push(...this.commonData.slice(this.currentPage * this.displayCount, (this.currentPage + 1) * this.displayCount));
      this.currentPage++;
      event.target.complete();
      if (this.displayData.length == this.commonData.length) {
        event.target.disabled = true;
      }
    }, 500);
  }

  setDisplayData() {
    if (this.commonData.length > this.displayCount) {
      this.displayData = this.commonData.slice(0, this.displayCount);
    }
    else {
      this.displayData = this.commonData;
    }
  }

  getBack() {
    this.location.back();
  }

  createPdf() {
    var obj = [];
    for (let i = 0; i < this.commonData.length; i++) {
      obj.push([this.commonData[i].plateNo, this.commonData[i].AlertType, this.commonData[i].status,
      this.commonData[i].startTime, this.commonData[i].endTime, this.commonData[i].duration])
    }
    this.commonService.downloadPdfReports(this.pdfHead, obj, "Alarm report")
  }


  ngOnInit() {
    this.commonData = companyReportData.reportData
    this.setDisplayData();
    //  this.commonData = JSON.parse('[{"date":"2020-09-15 14:48:42.0","min":20,"plateNo":"CDAC_Test_1","max":40,"name":"zone1","value":"29.1"},{"date":"2020-09-15 12:48:42.0","min":20,"plateNo":"CDAC_Test_1","max":40,"name":"zone2","value":"28.6"}]')
  }
  ngOnChanges() {
    this.commonData = companyReportData.reportData
    this.setDisplayData();
  }
}
